import { render, staticRenderFns } from "./SystemModuleSideMenu.vue?vue&type=template&id=6cfdc12d"
import script from "./SystemModuleSideMenu.vue?vue&type=script&lang=js"
export * from "./SystemModuleSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports